export interface FooterProps {
  applicationId: number
  documentId: number
  isSubmitting: boolean

  onSubmit: () => void
}
